<form #form="ngForm" (ngSubmit)="save(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-dropdown [options]="dateRanges" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="ppsDateRange" 
                    name="ppsDateRange" 
                    optionLabel="title"
                    [autoDisplayFirst]="false"
                    dataKey="id"
                    [(ngModel)]="selectedDateRange"
                    (onChange)="onDateRangeChanged($event)"></p-dropdown>
        <label for="ppsDateRange">Date Range</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="fromDate"
                    name="fromDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    required
                    #fromDate="ngModel"
                    [(ngModel)]="updateTravelStatusModel.dateRange.from"
                    [class.field-error]="form.submitted && fromDate.invalid"></p-calendar>
        <label for="fromDate" class="required-field">From</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && fromDate.invalid">From date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>

    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="toDate"
                    name="toDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    required
                    #toDate="ngModel"
                    [(ngModel)]="updateTravelStatusModel.dateRange.to"
                    [class.field-error]="form.submitted && toDate.invalid"></p-calendar>
        <label for="toDate" class="required-field">To</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && toDate.invalid">To date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>

    <div class="p-field p-col-12 p-md-3 p-mb-0">
      <span class="p-float-label">
        <p-dropdown [options]="travelStatuses" 
                    inputid="travelStatus"
                    name="travelStatus"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="name"
                    optionValue="id"
                    [autoDisplayFirst]="false"
                    required
                    #travelStatus="ngModel"
                    [(ngModel)]="updateTravelStatusModel.travelStatus"
                    [class.field-error]="form.submitted && travelStatus.invalid"></p-dropdown>
        <label for="travelStatus">Travel status</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && travelStatus.invalid">Travel status is required!</small>
    </div>    
  </div> 

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid p-m-2">
    <div class="text-danger text-small">
      The travel status for FIA, FOA, FIP, FOP, DIA, DOA, DIP, DOP within the selected date range will all be updated.
    </div>
  </div>
  
  <div class="modal-footer">
    <button pButton pRipple label="Ok" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
